import React, { useState, useEffect } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ModalThemMoiNhanVay } from "../ThemMoi/ModalThemMoiNhanVay";
import NhanVayApi from "service/nhanVayApi";
export const BtnSua = ({ NhanVayID }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);



  return (
    <>
      <a onClick={handleShow} href={() => false}>
        <PopoversBootrap
          contentText="Sửa"
          titleText=""
          trigger={["hover", "focus"]}
          placement={"top"}
        >
          <img src="/app-assets/images/icon-edit-v2.png" />
        </PopoversBootrap>
      </a>
      {show && (
        <ModalThemMoiNhanVay
          show={show}
          onHide={handleClose}
          NhanVayID={NhanVayID}
        />
      )}
    </>
  );
};
